import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { CASINO_LOBBY_GAMES } from '@environments/environment';
import { environment } from '@environments/environment';

@Component({
  selector: 'casinorulobby-component',
  templateUrl: '../sharedTemplates/casinorulobby-component.html',
})
export class CasinoRuLobbyComponent implements AfterViewInit {
  casinoList = [];

  selectedCasinoType = 0;

  gameTypes;
  provider;
  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.provider = params['provider'];
      //////console.log("PORVIDER______-----", this.provider);
    });
  }

  getCasinoGames() {
    this._ApiService.getCasinoRiseUpGames(this.provider).then((x: any) => {
      //////console.log("----x----", x);
      //////console.warn(this.provider,x);
      if (x != null && x.status == 'True') {
        this.gameTypes = x.data;
      } else {
        this._UiHelper.errorSnackBar(x.error, '');
      }

      //this.gameTypes = x.filter(s => s.Provider === this.provider);
      //////console.warn(this.provider, this.gameTypes);
    });
  }

  goGames(item) {
    let platform;
    if (environment.mobile) {
      platform = 'mobile';
    } else {
      platform = 'desktop';
    }

    this._ApiService.getCasinoRiseUpGameUrl(this.provider, item.id, 'real', platform).then((x: any) => {
      //////console.log("----getCasinoRiseUpGameUrl----", x);
      if (x != null && x.status == 'True') {
        window.location.href = x.data;
      } else {
        this._UiHelper.errorSnackBar(x.error, '');
      }
    });

    //window.location.href = item.LaunchUrl + "/?" + "defenceCode=" + item.defenceCode + "&playerId=" + item.playerId + "&portalCode=" + item.portal + "&screenName=" + item.userName + "&language=" + item.lang + "&country=de&client=" + platform + "&closeurl=" + item.rUrl + "&gameId=" + item.GameId;
    //this._router.navigate(['casinobs/'+item.GameId+'/'+item.ProductId]);
  }

  ngAfterViewInit() {
    if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();

    this._UiHelper.setNavbarTitle('Casino', true);
    this.getCasinoGames();
  }
}
